import React from 'react';
import {
  GET_TASK_COMMENTS,
  CREATE_TASK_COMMENT,
} from '../../../services/fragments/tasks';
import { useTaskDetail } from '../task-detail-provider';
import Comments from '../../../components/Comments/Comments';

const TaskComments = () => {
  const { task, setTaskComments } = useTaskDetail();
  const allowChanges = task.status !== 'Closed';
  return (
    <Comments
      parentPrimaryKey={parseFloat(task.id)}
      fetchGQL={GET_TASK_COMMENTS}
      createGQL={CREATE_TASK_COMMENT}
      fetchResponseKey="getTaskComments"
      setParentContext={setTaskComments}
      allowChanges={allowChanges}
    />
  );
};

export default TaskComments;
